import { Logo as LogoUi } from "@au-schein-de/au-ui-library";
import type { HTMLAttributes } from "react";

type LogoVariant = "default" | "white";

interface LogoProps extends HTMLAttributes<SVGSVGElement> {
	size?: number;
	variant?: LogoVariant;
}

export function Logo({ size, ...props }: LogoProps) {
	return <LogoUi showNewLogo={true} size={size} {...props} />;
}
